// @flow

import * as React from "react"
import {connect} from "react-redux"
import ClassNames from "classnames"

import {calcPrice} from "../reducers/baby"
import type {
  Product,
  ProductSet,
  BabyListItem,
  BabyList,
  State as ReduxState,
} from "../types"
import Icon from "./icon"

type Props = {
  +item: Product | ProductSet | BabyListItem,
  +babyList: BabyList,
  +amount: ?number,
}

export class PriceTag extends React.Component<Props> {
  render() {
    const {item, amount, babyList} = this.props
    const {totalPriceSelling, totalPriceNew} = calcPrice(
      item,
      amount === 0 ? 1 : amount,
      babyList
    )
    const classNames = ClassNames("price-tag", {
      "has-note": totalPriceNew.multiply(0.55).lessThan(totalPriceSelling),
      "is-zero": amount === 0,
    })
    return (
      <div className={classNames}>
        <div className="price-new">{totalPriceNew.toFormat("$0,0.00")}</div>
        <div className="sep">
          <Icon name="icon-chevron-right" />
        </div>
        <div className="price-selling">
          {!item.isSet && item.isPriceTbd ? (
            <span className="badge badge-light">TBD</span>
          ) : (
            totalPriceSelling.toFormat("$0,0.00")
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState): any => ({
  babyList: state.baby.list,
})

export default connect(mapStateToProps)(PriceTag)
